module.exports = __webpack_public_path__ + "static/pp_punkty-581a2aa2c2f182b9d6d8b601546fc160.gif";